/**
 * Shopify performance snippet:
 * 1. Defers ALL third-party app scripts until after the page has fully loaded
 * 2. Lazy-loads all images (except ones you explicitly mark as priority)
 *
 * HOW TO INSTALL:
 * - Online Store > Themes > Edit code > Assets > add a new file "defer-apps.js"
 * - Paste this code in
 * - In theme.liquid, add near the closing </body> tag:
 *     <script src="{{ 'defer-apps.js' | asset_url }}" defer></script>
 * - Then convert your app <script> tags to the "deferred" format described below.
 */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------------------------------------------------------
     PART 1: Defer all app scripts until after page load
     ---------------------------------------------------------
     Instead of letting Shopify apps inject <script src="..."> tags
     that run immediately, change them to:
       <script type="text/plain" data-deferred-src="https://app-script-url.js"></script>
     This snippet swaps them to real scripts only once the page
     has finished loading (window 'load' event = after all critical
     content, including images/fonts, has rendered).
  --------------------------------------------------------- */

  function loadDeferredScripts() {
    var deferredScripts = document.querySelectorAll('script[data-deferred-src]');

    deferredScripts.forEach(function (oldScript) {
      var newScript = document.createElement('script');

      // copy the real src across
      newScript.src = oldScript.getAttribute('data-deferred-src');

      // copy any other attributes (async, data-*, etc.) except the ones we handled
      Array.from(oldScript.attributes).forEach(function (attr) {
        if (attr.name !== 'type' && attr.name !== 'data-deferred-src') {
          newScript.setAttribute(attr.name, attr.value);
        }
      });

      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  // Fire after everything else has loaded, with a small buffer
  // so the app scripts don't compete with real page content for bandwidth.
  if (document.readyState === 'complete') {
    setTimeout(loadDeferredScripts, 1000);
  } else {
    window.addEventListener('load', function () {
      setTimeout(loadDeferredScripts, 1000);
    });
  }

  /* Fallback: also load deferred scripts on first user interaction
     (scroll, click, touch) in case 'load' takes a long time on slow
     connections — this way apps still work if a user engages early. */
  var interactionEvents = ['scroll', 'mousemove', 'touchstart', 'click'];
  var loadedOnInteraction = false;
  function loadOnFirstInteraction() {
    if (loadedOnInteraction) return;
    loadedOnInteraction = true;
    loadDeferredScripts();
    interactionEvents.forEach(function (evt) {
      window.removeEventListener(evt, loadOnFirstInteraction);
    });
  }
  interactionEvents.forEach(function (evt) {
    window.addEventListener(evt, loadOnFirstInteraction, { passive: true });
  });


  /* ---------------------------------------------------------
     PART 2: Lazy-load all images
     ---------------------------------------------------------
     Native lazy loading (loading="lazy") already works in modern
     browsers, but this adds an IntersectionObserver fallback and
     handles <img data-src="..."> patterns some apps/themes use.
  --------------------------------------------------------- */

  // 2a. Make sure every <img> not already marked has native lazy loading
  document.querySelectorAll('img:not([loading])').forEach(function (img) {
    // Skip images explicitly marked as priority (e.g. hero/LCP image)
    if (!img.classList.contains('priority-image')) {
      img.setAttribute('loading', 'lazy');
    }
  });

  // 2b. Handle apps/themes that use data-src instead of src (common pattern)
  var lazyImages = document.querySelectorAll('img[data-src]');

  if ('IntersectionObserver' in window) {
    var imageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          img.src = img.getAttribute('data-src');
          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
          }
          img.removeAttribute('data-src');
          img.removeAttribute('data-srcset');
          observer.unobserve(img);
        }
      });
    }, {
      rootMargin: '200px 0px', // start loading 200px before it enters viewport
      threshold: 0.01
    });

    lazyImages.forEach(function (img) {
      imageObserver.observe(img);
    });
  } else {
    // Fallback for very old browsers: just load everything immediately
    lazyImages.forEach(function (img) {
      img.src = img.getAttribute('data-src');
    });
  }

});